import PropTypes from 'prop-types';
import EditColumnStepModel from '../models/pipeline/steps/column_actions/edit_column';
import RenameColumnStepModel from '../models/pipeline/steps/column_actions/rename_column';
import SortColumnStepModel from '../models/pipeline/steps/column_actions/sort_column';
import DatasetModel from '../models/pipeline/steps/dataset';
import AddColumnStepModel from '../models/pipeline/steps/table_actions/add_column';
import HideColumnStepModel from "../models/pipeline/steps/column_actions/hide_column";


const pipelineStepPropType = PropTypes.oneOfType([
    PropTypes.instanceOf(DatasetModel),
    PropTypes.instanceOf(AddColumnStepModel),
    PropTypes.instanceOf(EditColumnStepModel),
    PropTypes.instanceOf(HideColumnStepModel),
    PropTypes.instanceOf(RenameColumnStepModel),
    PropTypes.instanceOf(SortColumnStepModel),
]);

export default pipelineStepPropType;
